import { memo } from 'react';

import type { FC, SVGAttributes } from 'react';

export interface InfoBlockIconProps extends SVGAttributes<SVGSVGElement> {
  className?: string;
}

const InfoBlockIcon3: FC<InfoBlockIconProps> = (props) => {
  return (
    <svg
      {...props}
      width='108'
      height='78'
      viewBox='0 0 108 78'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect x='18.9004' y='19.2407' width='79.6' height='53.6' fill='#BEEBFF' stroke='#404040' />
      <circle cx='18.4004' cy='18.7407' r='16.8613' fill='white' stroke='#404040' />
      <path
        d='M22.4057 20.4247C22.4057 22.8367 20.4077 24.4387 18.0677 24.4387C16.1417 24.4387 14.6837 23.3947 13.8917 21.8647L15.2237 20.9287C15.9437 22.0267 16.7897 22.6927 18.0137 22.6927C19.4357 22.6927 20.4437 21.7927 20.4437 20.4427C20.4437 19.0927 19.4537 18.3547 17.7077 18.3547H16.3937V17.8327L19.1657 14.1067H14.7377V12.3607H22.1357V12.8827L19.2557 16.7707C20.1377 16.9147 20.8757 17.3107 21.4877 17.9407C22.0997 18.5707 22.4057 19.3987 22.4057 20.4247Z'
        fill='#404040'
      />
      <rect x='15' y='72.5405' width='87.4' height='4.2' fill='#BEEBFF' stroke='#404040' />
      <path
        d='M77.4457 46.1366V42.5312C77.4457 41.2741 76.4942 40.3128 75.2499 40.3128H61.4165C60.1722 40.3128 59.2207 41.2741 59.2207 42.5312M59.2207 42.5312C59.2207 41.2741 58.2692 40.3128 57.0249 40.3128H43.1916C41.9473 40.3128 40.9957 41.2741 40.9957 42.5312V46.1572M59.2207 42.5312V46.1366M82.2764 48.4469C82.2764 47.1898 81.3249 46.2285 80.0806 46.2285H38.3608C37.1165 46.2285 36.165 47.1898 36.165 48.4469V50.6652M76.2485 50.7391H36.165V57.3943C36.165 58.6514 37.1165 59.6127 38.3608 59.6127H73.1435M80.6662 46.2285V35.0626C80.6662 33.8055 79.7146 32.8442 78.4704 32.8442H39.9711C38.7268 32.8442 37.7753 33.8055 37.7753 35.0626V46.2285H80.6662ZM40.1906 59.6127V63.9016H41.7277L42.606 60.7958V59.6127H40.1906Z'
        stroke='#404040'
        strokeMiterlimit='10'
      />
      <path d='M77.9648 58.1519L80.9286 60.2233L87.1152 55.0762' stroke='#404040' />
      <circle cx='82.0996' cy='57.7407' r='9.05859' stroke='#404040' />
    </svg>
  );
};

export default memo(InfoBlockIcon3);
